var _path, _path2, _path3, _rect, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10.6667H25.3332V22.6667C25.3332 24.5523 25.3332 25.4951 24.7474 26.0809C24.1616 26.6667 23.2188 26.6667 21.3332 26.6667H10.6665C8.78089 26.6667 7.83808 26.6667 7.25229 26.0809C6.6665 25.4951 6.6665 24.5523 6.6665 22.6667V10.6667Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 10.6667L15.6809 7.79611C15.4829 6.01451 13.9562 4.66666 12.1636 4.66666V4.66666C10.2449 4.66666 8.6665 6.22205 8.6665 8.14072V8.14072C8.6665 9.30229 9.24702 10.387 10.2135 11.0313L12.6665 12.6667",
    stroke: "#717171",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 10.6667L16.3191 7.79611C16.5171 6.01451 18.0438 4.66666 19.8364 4.66666V4.66666C21.7551 4.66666 23.3335 6.22205 23.3335 8.14072V8.14072C23.3335 9.30229 22.753 10.387 21.7865 11.0313L19.3335 12.6667",
    stroke: "#717171",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.3335,
    y: 10.6667,
    width: 21.3333,
    height: 4,
    fill: "#717171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.6667V20",
    stroke: "#222222",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPromotion);
export default __webpack_public_path__ + "static/media/icon_promotion.407912442827e67648b76cb3e6ce5ba6.svg";
export { ForwardRef as ReactComponent };